module.exports = __webpack_public_path__ + "static/media/proj10_img2.f3ebbd1e.jpg";